import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { AuthUtilService } from '../_util/auth-util.service';

@Injectable({
  providedIn: 'root'
})
export class IsLoggedInGuard  {
  constructor(private _authUtilService: AuthUtilService,
    private _router: Router){}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean>{
    if(await this._authUtilService.isLoggedIn()) return true
    this._router.navigate(['/login'],{queryParams:{redirect:state.url}})
    return false
  }
  async canLoad(route: Route, segments: UrlSegment[]): Promise<boolean>{
    if(await this._authUtilService.isLoggedIn()) return true
    this._router.navigate(['/login'],{queryParams:{redirect:segments.reduce((path, currentSegment) => { return `${path}/${currentSegment.path}`;}, '')}})
    return false
  }
}
